import { Component, Input } from '@angular/core';
import { navItems } from '../../_nav';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {
  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  public _data: any;
  
  constructor() {
    this._data = JSON.parse(localStorage.getItem('user_data'));
    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });

    this.changes.observe(<Element>this.element, {
      attributes: true
    });
  }

  logout(): void {
    console.log('Loggin you out');
    localStorage.removeItem('token');
    localStorage.removeItem('user_data');
  }
}
